export default "### 2021-07-20 - Portal v4.1.2 Galileo  \n---\nFeatures  \n-   Stability, security, and performance updates\n"